import APIService from '@/services/api-service'
const resource = '/employee'

class EmployeeModalService extends APIService {
  public constructor () {
    super()
    this.mountAuthorizationToken()
  }

  public getEmployee (id: any) {
    return this.connector.get(`${resource}/${id}`)
  }

  public getAddress (employeeId: any, type: any) {
    return this.connector.get(`${resource}/${employeeId}/address/${type}`)
  }

  public create (employee: any) {
    return this.connector.post(`${resource}/create`, { employee: employee })
  }

  public update (employee: any) {
    return this.connector.put(`${resource}/update`, { employee: employee })
  }
}

export default new EmployeeModalService()
